<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('user', [
      'cloudStorage',
      'user',
      'profile'
    ]),
    userName () {
      return this.user.name
    },
    cloudStoragePercent () {
      return Math.floor((this.cloudStorage.usedStorage * 100) / this.cloudStorage.availableStorage) || 0
    },
    cloudStorageAvailableGb () {
      const gb = 1024 * 1024 * 1024
      return Math.floor((this.cloudStorage.availableStorage / gb) * 100) / 100 || 0
    }
  }
}
</script>
